<input
  #timeInput
  [formControl]="displayedTimeFormControl"
  (keydown)="timeInputKeyDown($event)"
  (beforeinput)="timeInputTransform($event, displayedTimeFormControl)"
  (paste)="timeInputPaste($event, displayedTimeFormControl)"
  (click)="openTimePicker()"
  (blur)="timeInputBlur($event, displayedTimeFormControl)"
  (focus)="moveCarriage('end', timeInput); openTimePicker()"
  data-cy="FieldInput:TimeInput"
  class="input-datetime flex-[2]"
/>

<div #timeMenuTrigger [matMenuTriggerFor]="menu"></div>
<mat-menu
  #menu
  class="bd-menu inline-editor-time-picker shadow-dropdown"
  [hasBackdrop]="false"
  [xPosition]="'before'"
>
  <ng-template matMenuContent>
    @let timeProposalArray = (timeProposalArray$ | async) || [];
    <blaze-scroller>
      @for (timeProposal of timeProposalArray; track timeProposal) {
        <button
          class="min-w-[90px]"
          [class.selected]="pickedTimeForSelectedMarker === timeProposal"
          mat-menu-item
          [value]="timeProposal"
          (click)="patchTimeProposal(timeProposal); closeTimePicker()"
        >
          {{ timeProposal }}
        </button>
      }
    </blaze-scroller>
  </ng-template>
</mat-menu>
